import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { environment } from '../../../../environments/environment';
import { MyChartIsEpicIconSvgComponent } from "../../../../assets/svg/web/mychart-is-epic";
import { CommonModule } from '@angular/common';
import { provideProtractorTestingSupport } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { getLocaleFromUrl } from '../../services/translate/locale-utils';
import { MonitoringService } from '../../services/monitoring/monitoring-service';

@Component({
  selector: 'app-mychart-web-header',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, TranslateModule],
  templateUrl: './mychart-web-header.component.html',
  styleUrl: './mychart-web-header.component.css'
})
export class MychartWebHeaderComponent {
  @Input() firstName: string | null = null;
  
  @ViewChild('mainMenu') mainMenu!: MatMenu;
  @ViewChild('languageMenu') languageMenu!: MatMenu;
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  activeMenu!: MatMenu;

  selectedMenu: 'main' | 'language' = 'main';

  

  languageOptions = [
    { label: 'English', value: 'en-US' },
    { label: 'Español', value: 'es-US' },
    { label: '繁體中文', value: 'zh-US-HANZ' },
    { label: 'Tiếng Việt', value: 'vi-US' }
  ];

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) { 
    // Set the default language for translations
    this.translate.setDefaultLang('en-US');
    const language = getLocaleFromUrl();
    this.translate.use(language);
  }

  ngOnInit() {
    this.activeMenu = this.mainMenu; // Set the initial active menu to mainMenu

    // Set the initial focus to the English button if the locale is 'en-US'
    if (this.locale === 'es-US') {
      this.languageOptions = [
        { label: 'Español', value: 'es-US' },
        { label: 'English', value: 'en-US' }
      ];
    }



  }

  public get firstInitial(): string | null {
    return this.firstName && this.firstName.length > 0 ? this.firstName[0] : null;
  }

  public get locale(): string {
    return new URL(window.location.href).searchParams.get('locale') || 'en-US';
  }

  switchMenu(menuToActivate: 'main' | 'language') {
    // this.activeMenu = this.mainMenu; // Default to main menu
    // this.trigger.menu = this.activeMenu; // Set the trigger's menu to the active menu

    if (menuToActivate === 'main') {
      this.selectedMenu = 'main'; 
      
    } else if (menuToActivate === 'language') {
      this.selectedMenu = 'language';
    }

    this.trigger.menu = this.mainMenu;
    setTimeout(() => {
      this.trigger.openMenu(); // Open the menu
    }, 10);

  }

  navigateToMyChart(option: string) {
    var url = '';

    switch (option) {
      case 'home':
        url = environment.web_mychart_home_url;
        
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        const firstSubdirectory = pathSegments.length > 0 ? pathSegments[0] : '';
        console.log('First subdirectory:', firstSubdirectory);

        this.monitoringService.logEvent('NavToHome', { feature: firstSubdirectory, platform: 'web' }); // log as web event
        break;
      case 'family-access':
        url = environment.web_mychart_proxy_family_access_url;
        break;
      case 'personal-info':
        url = environment.web_mychart_personal_info_url;
        break;
      case 'settings':
        url = environment.web_mychart_security_settings_url;
        break;
      case 'logout':
        url = environment.web_mychart_logout_url;
        break;
      default:
        url = '';
        break;
    }

    if (url != '') {
      window.location.href = url;
    }
    
  }
  
  changeLanguage(language: string) {
    // Logic to change the language of the application
    console.log(`Language changed to: ${language}`);
    // This could involve calling a service to update the language setting
    const url = new URL(window.location.href);
    url.searchParams.set('locale', language);
    window.location.href = url.toString();
  }

  

}
